import React from 'react'
import { useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import { Link } from 'react-router-dom'
import { Image } from 'react-bootstrap'
import logo from '../assets/images/aicte_logo_sign.png'
import anuvadini from '../assets/images/Anuvadini.png'
import MenuOpen from '../assets/images/bars.png'
import MOE from '../assets/images/logo_ministry.png'
import image23 from '../assets/images/icon_image-23.svg'
import image22 from '../assets/images/ububu.png'
import image25 from '../assets/images/handwritten.png'
import ImageVariation from '../assets/images/image-6.png'
import PhotoToSketch from '../assets/images/image-3.png'
import SketchRendering from '../assets/images/image-1.png'
import TextEffects from '../assets/images/image-8.png'
import HDUpscaler from '../assets/images/image-9.png'
import EraseReplace from '../assets/images/image-10.png'
import Outpainting from '../assets/images/image-11.png'
import Relight from '../assets/images/image-12.png'
import ImagetoVideo from '../assets/images/image-13.png'
import TexttoVideo from '../assets/images/image-14.png'
import FaceCutout from '../assets/images/face.png'
import ytanalyzer from '../assets/images/yt.jpg'
// import { FilePdf } from 'phosphor-react'
import coreEngg from '../assets/images/icon_engineering.svg'
// import ai from '../assets/images/ai.png'
// import image23 from "../assets/images/icon_image-23.svg";
// import camera from '../assets/images/camera.png'
import analyzer from '../assets/images/icon_ai-video-analyzer.svg'
import doctrans from '../assets/images/icon/translation/documents-tran.png'
import chutki from '../assets/images/icon/translation/chutiki-icon.png'
import voice from '../assets/images/icon/translation/voice01.png'
import legal from '../assets/images/icon/translation/legal.png'
import virtual from '../assets/images/icon/translation/virtual-keyword-icon.png'
import govt from '../assets/images/icon/translation/govt.png'
import Dictation from '../assets/images/icon/translation/judge.png'
import bhasha from '../assets/images/icon/translation/bhasha-dan-icn.png'
import videotranslation from '../assets/images/icon/translation/video-translation.svg'
import textTo from '../assets/images/icon/voice/text-to-speech.png'
import voicetotext from '../assets/images/icon/voice/text-to-text.png'

import ananta from '../assets/images/icon/translation/ananta.png'
import BharatAudliv from '../assets/images/New-logo/BharatAudioLive.png'
import BharatVidliv from '../assets/images/New-logo/BharatVideoLive.png'
import BharatTube from '../assets/images/New-logo/BharatTube.png'
import BharatSpeech from '../assets/images/Bharat-Messenger.png'
import BharatSandesh from '../assets/images/BharatSandesh.png'
import ImmersiveAi from '../assets/images/immersive-ai.png'
import {
    merge,
    Split,
    compress,
    pagenum,
    PdftoImages,
    ImagestoPdf,
    ProtectPdf,
    UnlockPdf,
    TxttoPdf,
    CreatePdf,
    Pdfword,
    JpgtoPdf,
    watermark,
    DocxtoPdf,
    PpttoPdf,
    ExceltoPdf,
    PdftoTxt,
    images,
} from '../AllImages'

function Header() {
    const [show, setShow] = useState(false)
    const [authCategory, setAuthCategory] = useState(0)
    const handleClose = () => setShow(false)
    // const handleShow = () => setShow(true)
    const [manu, setMenu] = useState(false)
    const menuHandle = () => {
        setMenu(!manu)
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        })
    }
    return (
        <div>
            <header>
                <div className="row">
                    <div className="logo-sec col-lg-4 text-start">
                        <Link to="/" title="" className="anuvadini">
                            <Image src={anuvadini} alt="Logo" width="205px" />
                        </Link>
                        <Link
                            to="https://www.education.gov.in/"
                            title=""
                            target="_blank"
                            rel="noreferrer"
                        >
                            <Image src={MOE} alt="Logo" width={110} />
                        </Link>
                        <Link
                            to="https://www.aicte-india.org/"
                            className="aicte"
                            title=""
                            target="_blank"
                            rel="noreferrer"
                        >
                            <Image src={logo} alt="Logo" width={55} />
                        </Link>
                    </div>

                    <div
                        className={
                            manu === true
                                ? 'menu-sec col-lg-8 openMenu'
                                : 'menu-sec col-lg-8'
                        }
                    >
                        <ul>
                            <li>
                                <Link to="/" onClick={menuHandle}>
                                    Home
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to={undefined}
                                    title="Translation"
                                    className="translationMenu dropdown-toggle"
                                    id="dropdownMenuButton"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    Translation
                                    <svg
                                        data-v-7e3b073a=""
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        role="Image"
                                        aria-hidden="true"
                                        className="v-icon__svg"
                                        style={{
                                            fontSize: 14,
                                            height: 14,
                                            width: 14,
                                        }}
                                    >
                                        <path
                                            data-v-7e3b073a=""
                                            d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
                                        ></path>
                                    </svg>
                                </Link>
                                <div
                                    className="navDropDown translationDropDown dropdown-menu"
                                    aria-labelledby="dropdownMenuButton"
                                >
                                    <ul>
                                        <li className="drop-menu-item">
                                            <Link
                                                target="_blank"
                                                rel="noreferrer"
                                                onClick={menuHandle}
                                                to="https://translation.aicte-india.org/translation-independent/"
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <Image src={doctrans} />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Online Document
                                                            Translation Tool
                                                        </div>
                                                        <p className="chakra-text css-itvw0n">
                                                            Including Online
                                                            Editor
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="drop-menu-item">
                                            <Link
                                                target="_blank"
                                                rel="noreferrer"
                                                onClick={menuHandle}
                                                to="https://translation.aicte-india.org/translation-independent/Text-Editor/"
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <Image src={chutki} />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Chutki
                                                        </div>
                                                        <p className="chakra-text css-itvw0n">
                                                            Real-Time Doc
                                                            Translation Service
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="drop-menu-item">
                                            <a
                                                target="_blank"
                                                rel="noreferrer"
                                                href="https://anuvadiniqa.aicte-india.org/"
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <Image src={ananta} />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Ananta
                                                        </div>
                                                        <p className="chakra-text css-itvw0n">
                                                            infinite deep search
                                                            generative AI engine
                                                            for ms word, pdf,
                                                            pptx, text, audio
                                                            and video
                                                        </p>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>

                                        <li className="drop-menu-item">
                                            <Link
                                                target="_blank"
                                                rel="noreferrer"
                                                to="https://anuvadini.aicte-india.org/voiceform/"
                                                onClick={menuHandle}
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <Image src={voice} />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Voice Based
                                                            Multilingual Form
                                                        </div>
                                                        <p className="chakra-text css-itvw0n">
                                                            a web tool to create
                                                            form to any Indian
                                                            languages
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="drop-menu-item">
                                            <Link
                                                target="_blank"
                                                rel="noreferrer"
                                                to="https://translation.aicte-india.org/translation-independent/PmModiNationalInternshipPortal/"
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <Image
                                                            src={
                                                                videotranslation
                                                            }
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Video Translation
                                                        </div>
                                                        <p className="chakra-text css-itvw0n">
                                                            A tool to make video
                                                            translation to any
                                                            Indian languages
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="drop-menu-item">
                                            <Link
                                                to="https://translation.aicte-india.org/translation-independent/transliterate/"
                                                target="_blank"
                                                rel="noreferrer"
                                                onClick={menuHandle}
                                            >
                                                <div className="css-hboir5">
                                                    <div
                                                        className="css-1hnxo7a"
                                                        style={{ width: 75 }}
                                                    >
                                                        <img src={virtual} />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Virtual Keyboard
                                                        </div>
                                                        <p className="chakra-text css-itvw0n">
                                                            A web tool to type
                                                            in any Indian
                                                            languages
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="drop-menu-item">
                                            <Link
                                                target="_blank"
                                                rel="noreferrer"
                                                to="https://anuvadini.aicte-india.org/govtofindiascheme/"
                                                onClick={menuHandle}
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <Image src={govt} />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Govt of India
                                                            Schemes
                                                        </div>
                                                        <p className="chakra-text css-itvw0n">
                                                            Schemes &
                                                            Initiatives Voice
                                                            Based Search (Chat
                                                            GPT)
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="drop-menu-item">
                                            <Link
                                                target="_blank"
                                                rel="noreferrer"
                                                to="https://anuvadini.aicte-india.org/dictation-tool/"
                                                onClick={menuHandle}
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <Image
                                                            src={Dictation}
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Dictation Tool
                                                        </div>
                                                        <p className="chakra-text css-itvw0n">
                                                            This tool is useful
                                                            for making note
                                                            taking easier
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="drop-menu-item">
                                            <Link
                                                target="_blank"
                                                rel="noreferrer"
                                                to="https://anuvadini.aicte-india.org/lawdictionary/"
                                                onClick={menuHandle}
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <Image src={legal} />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Legal Glossary
                                                        </div>
                                                        <p className="chakra-text css-itvw0n">
                                                            Access to a
                                                            comprehensive and
                                                            authentic respoitory
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>

                                        <li className="drop-menu-item">
                                            <Link
                                                target="_blank"
                                                rel="noreferrer"
                                                to="https://anuvadini.aicte-india.org/Bhasha-daan/"
                                                onClick={menuHandle}
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <Image src={bhasha} />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Bhasha Daan
                                                        </div>
                                                        <p className="chakra-text css-itvw0n">
                                                            (Discover and Author
                                                            the collection of
                                                            Indian language
                                                            words and sentences)
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </li>

                            <li>
                                <Link
                                    to={undefined}
                                    title="Video"
                                    className="videoMenu dropdown-toggle"
                                    id="dropdownMenuButton4"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    Video
                                    <svg
                                        data-v-7e3b073a=""
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        role="Image"
                                        aria-hidden="true"
                                        className="v-icon__svg"
                                        style={{
                                            fontSize: 14,
                                            height: 14,
                                            width: 14,
                                        }}
                                    >
                                        <path
                                            data-v-7e3b073a=""
                                            d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
                                        ></path>
                                    </svg>
                                </Link>
                                <div
                                    className="navDropDown videoDropDown dropdown-menu"
                                    aria-labelledby="dropdownMenuButton4"
                                >
                                    <ul>
                                        <li>
                                            <Link
                                                target="_blank"
                                                rel="noreferrer"
                                                to="https://bharattube.aicte-india.org/session"
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <Image
                                                            src={BharatAudliv}
                                                            style={{
                                                                width: '100%',
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <p className="chakra-text css-itvw0n">
                                                            Speak with lakhs of
                                                            users in their
                                                            Bharatiya (Indian)
                                                            Languages
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                target="_blank"
                                                rel="noreferrer"
                                                to="https://bharattube.aicte-india.org/stream"
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <Image
                                                            src={BharatVidliv}
                                                            style={{
                                                                width: '100%',
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <p className="chakra-text css-itvw0n">
                                                            Streaming Unity in
                                                            Diversity of Bharat.
                                                            Translates live
                                                            YouTube channels
                                                            into various
                                                            Bharatiya (Indian)
                                                            languages, breaking
                                                            linguistic barriers.
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="drop-menu-item">
                                            <a
                                                target="_blank"
                                                rel="noreferrer"
                                                href="https://bharattube.aicte-india.org/realtimeVideo"
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a bharatTube">
                                                        <Image
                                                            src={BharatTube}
                                                            alt=""
                                                            style={{
                                                                width: '100%',
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <p className="chakra-text css-itvw0n">
                                                            YouTube videos in
                                                            Bharatiya (Indian)
                                                            languages
                                                        </p>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                        <li>
                                            <Link
                                                target="_blank"
                                                rel="noreferrer"
                                                to="https://speech.aicte-india.org/"
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <Image
                                                            src={BharatSpeech}
                                                            style={{
                                                                width: '100%',
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <p className="chakra-text css-itvw0n">
                                                            Communicate with
                                                            your Bharatiya
                                                            (Indian) language
                                                            and Foreign
                                                            languages(text,
                                                            audio or video
                                                            supported)
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>

                                        <li className="drop-menu-item">
                                            <Link
                                                to="/video/"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <Image
                                                            src={analyzer}
                                                            alt=""
                                                            width="50px"
                                                        ></Image>
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            AI Video Analyzer
                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="drop-menu-item">
                                            <Link
                                                target="_blank"
                                                rel="noreferrer"
                                                to={
                                                    'https://anuvadini.aicte-india.org/youtube-analyzer'
                                                }
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <img
                                                            src={ytanalyzer}
                                                            alt="yt-analyser"
                                                            style={{
                                                                width: '50%',
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            AI Youtube-Video
                                                            Analyser
                                                        </div>
                                                        <p className="chakra-text css-itvw0n"></p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                target="_blank"
                                                rel="noreferrer"
                                                to={
                                                    'https://anuvadini.aicte-india.org/immersive-ai/'
                                                }
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <Image
                                                            src={ImmersiveAi}
                                                            style={{
                                                                width: '100%',
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        {/* <div className="chakra-heading css-9f6g39">
                              Immersive AI
                            </div> */}
                                                        <p className="chakra-text css-itvw0n">
                                                            Enhance
                                                            communication by
                                                            creating customized,
                                                            Personalized and
                                                            impressive video
                                                            experiences with
                                                            Anuvadini Immersive
                                                            AI feature.
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li
                                            style={{
                                                opacity: 0.3,
                                                filter: 'grayscale(100%)',
                                            }}
                                        >
                                            <Link
                                                // target="_blank"
                                                rel="noreferrer"
                                                // to="https://speech.aicte-india.org/"
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <Image
                                                            src={BharatSandesh}
                                                            style={{
                                                                width: '100%',
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <p className="chakra-text css-itvw0n">
                                                            translate your phone
                                                            calls live with your
                                                            Bharatiya (Indian)
                                                            language and Foreign
                                                            languages.
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                            <li>
                                <Link
                                    to={undefined}
                                    title="Translation"
                                    className="voiceMenu dropdown-toggle"
                                    id="dropdownMenuButton2"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    Voice
                                    <svg
                                        data-v-7e3b073a=""
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        role="Image"
                                        aria-hidden="true"
                                        className="v-icon__svg"
                                        style={{
                                            fontSize: 14,
                                            height: 14,
                                            width: 14,
                                        }}
                                    >
                                        <path
                                            data-v-7e3b073a=""
                                            d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
                                        ></path>
                                    </svg>
                                </Link>
                                <div
                                    className="navDropDown voiceDropDown dropdown-menu"
                                    aria-labelledby="dropdownMenuButton2"
                                >
                                    <ul>
                                        <li className="drop-menu-item">
                                            <Link
                                                target="_blank"
                                                rel="noreferrer"
                                                to="https://voice.aicte-india.org/"
                                                onClick={menuHandle}
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <Image src={textTo} />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Bhashin
                                                        </div>
                                                        <p className="chakra-text css-itvw0n">
                                                            Translation Services
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="drop-menu-item">
                                            <Link
                                                target="_blank"
                                                rel="noreferrer"
                                                to="https://voice.aicte-india.org/"
                                                onClick={menuHandle}
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <Image
                                                            src={voicetotext}
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Voice to Text, Text
                                                            to Voice
                                                        </div>
                                                        <p className="chakra-text css-itvw0n">
                                                            Text to Text, Image
                                                            to Text Translation
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="drop-menu-item">
                                            <Link
                                                to="/ThreeDAudio"
                                                onClick={menuHandle}
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <svg
                                                            height="100%"
                                                            width="100%"
                                                            xmlSpace="preserve"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 512 512"
                                                            fill="#E53E3E"
                                                            stroke="#E53E3E"
                                                        >
                                                            <path d="M224 241H72c-8.284 0-15 6.716-15 15v80c0 8.284 6.716 15 15 15h112c5.682 0 10.875-3.21 13.417-8.292l40-80A15 15 0 0 0 224 241Zm-49.271 80H87v-50h112.729zM440 241H288a15 15 0 0 0-13.417 21.708l40 80A15.001 15.001 0 0 0 328 351h112c8.284 0 15-6.716 15-15v-80c0-8.284-6.716-15-15-15zm-15 80h-87.729l-25-50H425Z"></path>
                                                            <path d="m506.544 188.428-97-80A15 15 0 0 0 385 120v65H127v-65a14.998 14.998 0 0 0-8.603-13.567 14.997 14.997 0 0 0-15.941 1.995l-97 80A15.001 15.001 0 0 0 0 200v162c0 24.813 20.187 45 45 45h160.459c17.154 0 32.577-9.532 40.25-24.875L256 361.542l10.292 20.583c7.672 15.343 23.095 24.875 40.25 24.875H467c24.813 0 45-20.187 45-45V200c0-4.478-2.001-8.722-5.456-11.572zM415 151.815 455.237 185H415ZM97 185H56.763L97 151.815Zm370 192H306.541a14.92 14.92 0 0 1-13.417-8.292l-23.708-47.417a15 15 0 0 0-26.833.001l-23.708 47.416A14.917 14.917 0 0 1 205.458 377H45c-8.271 0-15-6.729-15-15V215h452v147c0 8.271-6.729 15-15 15z"></path>
                                                        </svg>
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            3D Audio
                                                        </div>
                                                        <p className="chakra-text css-itvw0n">
                                                            Enhance the stereo
                                                            sound by adding a 3D
                                                            effect to it
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="drop-menu-item">
                                            <Link
                                                to="/AutoPartner"
                                                onClick={menuHandle}
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <svg
                                                            height="100%"
                                                            width="100%"
                                                            xmlSpace="preserve"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 512 512"
                                                            fill="#DD6B20"
                                                            stroke="#DD6B20"
                                                        >
                                                            <path d="M255 16C114.06 16 0 130.05 0 271v150c0 24.813 20.187 45 45 45h17.58c6.192 17.458 22.865 30 42.42 30 24.813 0 45-20.187 45-45V331c0-24.813-20.187-45-45-45a44.79 44.79 0 0 0-15 2.58V271c0-90.847 73.891-165 165-165 92.084 0 167 74.019 167 165v17.58a44.785 44.785 0 0 0-15-2.58c-24.813 0-45 20.187-45 45v120c0 24.813 20.187 45 45 45 19.555 0 36.228-12.542 42.42-30H467c24.813 0 45-20.187 45-45V271c0-141.759-117.098-255-257-255Zm167 435c0 8.271-6.729 15-15 15s-15-6.729-15-15V331c0-8.271 6.729-15 15-15s15 6.729 15 15zM60 436H45c-8.271 0-15-6.729-15-15v-60c0-8.271 6.729-15 15-15h15zm45-120c8.271 0 15 6.729 15 15v120c0 8.271-6.729 15-15 15s-15-6.729-15-15V331c0-8.271 6.729-15 15-15zm-45-45v45H45a44.79 44.79 0 0 0-15 2.58V271c0-56.646 21.05-108.463 55.728-148.06l21.256 21.256C77.713 178.316 60 222.626 60 271ZM255 76c-48.374 0-92.685 17.712-126.803 46.984l-21.256-21.256C146.537 67.05 198.354 46 255 46c57.324 0 109.744 21.181 149.739 56.048l-21.447 21.447C347.408 92.771 302.37 76 255 76Zm227 345c0 8.271-6.729 15-15 15h-15v-90h15c8.271 0 15 6.729 15 15zm0-102.42a44.785 44.785 0 0 0-15-2.58h-15v-45c0-46.701-16.737-91.006-47.424-126.363l21.435-21.435C460.859 162.765 482 214.479 482 271Z"></path>
                                                        </svg>
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Auto Panner
                                                        </div>
                                                        <p className="chakra-text css-itvw0n">
                                                            Make the audio
                                                            alternate from left
                                                            to right
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="drop-menu-item">
                                            <Link
                                                to="/BassBooster"
                                                onClick={menuHandle}
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <svg
                                                            height="100%"
                                                            width="100%"
                                                            xmlSpace="preserve"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 512 512"
                                                            fill="#D69E2E"
                                                            stroke="#D69E2E"
                                                        >
                                                            <path d="M256 60.25C148.063 60.25 60.25 148.063 60.25 256S148.063 451.75 256 451.75 451.75 363.937 451.75 256 363.937 60.25 256 60.25Zm0 361.5c-91.395 0-165.75-74.355-165.75-165.75S164.605 90.25 256 90.25 421.75 164.605 421.75 256 347.395 421.75 256 421.75z"></path>
                                                            <path d="M256 180.75c-41.493 0-75.25 33.757-75.25 75.25s33.757 75.25 75.25 75.25 75.25-33.757 75.25-75.25-33.757-75.25-75.25-75.25zm0 120.5c-24.951 0-45.25-20.299-45.25-45.25s20.299-45.25 45.25-45.25 45.25 20.299 45.25 45.25-20.299 45.25-45.25 45.25z"></path>
                                                            <path d="M330.6 160.188c-5.858 5.857-5.858 15.355 0 21.213 19.927 19.927 30.9 46.42 30.9 74.6 0 28.18-10.974 54.673-30.9 74.6-5.858 5.857-5.858 15.355 0 21.213a14.95 14.95 0 0 0 10.606 4.394c3.838 0 7.678-1.465 10.606-4.394C377.405 326.221 391.5 292.193 391.5 256c0-36.193-14.095-70.221-39.688-95.812-5.857-5.858-15.355-5.858-21.212 0zM150.5 256c0-28.18 10.974-54.674 30.9-74.6 5.858-5.857 5.858-15.355 0-21.213-5.858-5.858-15.355-5.858-21.213 0C134.594 185.779 120.5 219.807 120.5 256c0 36.193 14.094 70.221 39.687 95.812a14.954 14.954 0 0 0 10.606 4.394c3.838 0 7.678-1.465 10.606-4.394 5.858-5.857 5.858-15.355 0-21.213C161.474 310.674 150.5 284.18 150.5 256Z"></path>
                                                            <path d="M486.223 368.058C503.327 332.983 512 295.282 512 256c0-39.282-8.673-76.983-25.777-112.058a12.335 12.335 0 0 1 2.569-14.359l-.001.001c15.784-15.11 24.208-36.318 23.112-58.185-.93-18.55-8.739-36.062-21.989-49.313C476.663 8.836 459.15 1.026 440.601.097c-21.872-1.089-43.074 7.329-58.184 23.111a12.333 12.333 0 0 1-14.359 2.569C332.983 8.673 295.282 0 256 0c-39.282 0-76.983 8.673-112.057 25.777a12.332 12.332 0 0 1-14.359-2.568C114.472 7.424 93.26-.997 71.4.097c-18.55.93-36.064 8.739-49.314 21.989C8.835 35.337 1.026 52.851.096 71.401c-1.095 21.865 7.329 43.071 23.112 58.183a12.332 12.332 0 0 1 2.57 14.358C8.673 179.017 0 216.718 0 256c0 39.282 8.673 76.983 25.778 112.058a12.333 12.333 0 0 1-2.569 14.358C7.425 397.527-.999 418.733.096 440.6c.93 18.55 8.739 36.063 21.989 49.314 13.25 13.25 30.764 21.06 49.314 21.989 21.869 1.091 43.073-7.328 58.185-23.111a12.328 12.328 0 0 1 14.359-2.569C179.017 503.327 216.718 512 256 512s76.983-8.673 112.058-25.777a12.333 12.333 0 0 1 14.358 2.568c15.11 15.783 36.308 24.206 58.185 23.112 18.55-.93 36.062-8.739 49.313-21.989 13.25-13.251 21.06-30.764 21.989-49.313 1.096-21.866-7.328-43.074-23.111-58.184a12.333 12.333 0 0 1-2.569-14.359zm-18.178 36.028c9.491 9.086 14.556 21.848 13.896 35.013-1.146 22.878-19.964 41.696-42.842 42.842-13.155.655-25.927-4.405-35.014-13.896-12.795-13.361-32.558-16.892-49.178-8.786C323.964 474.349 290.687 482 256 482s-67.964-7.651-98.907-22.742a42.39 42.39 0 0 0-18.608-4.314c-11.278 0-22.36 4.526-30.569 13.101-9.088 9.492-21.851 14.551-35.014 13.896-22.877-1.146-41.695-19.965-42.842-42.843-.66-13.164 4.405-25.926 13.896-35.012 13.362-12.794 16.893-32.558 8.787-49.179C37.651 323.964 30 290.687 30 256s7.651-67.964 22.742-98.908c8.105-16.621 4.574-36.384-8.788-49.178-9.49-9.086-14.555-21.848-13.896-35.012 1.147-22.878 19.965-41.697 42.843-42.843a45.285 45.285 0 0 1 35.014 13.896c12.793 13.362 32.556 16.891 49.178 8.786C188.036 37.651 221.313 30 256 30s67.964 7.651 98.907 22.742c16.621 8.105 36.383 4.576 49.179-8.787 9.087-9.49 21.856-14.554 35.013-13.896 22.878 1.146 41.696 19.964 42.842 42.842.66 13.165-4.404 25.927-13.896 35.013l-.001.001c-13.361 12.794-16.892 32.557-8.786 49.178C474.349 188.036 482 221.313 482 256s-7.651 67.964-22.742 98.907c-8.106 16.621-4.575 36.384 8.787 49.179z"></path>
                                                        </svg>
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Bass Booster
                                                        </div>
                                                        <p className="chakra-text css-itvw0n">
                                                            Boost the bass of a
                                                            song making it more
                                                            bass heavy
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="drop-menu-item">
                                            <Link
                                                to="/Equalizer"
                                                onClick={menuHandle}
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <svg
                                                            height="100%"
                                                            width="100%"
                                                            xmlSpace="preserve"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 512 512"
                                                            fill="#38A169"
                                                            stroke="#38A169"
                                                        >
                                                            <path d="M467 31H45C20.187 31 0 51.187 0 76v360c0 24.813 20.187 45 45 45h422c24.813 0 45-20.187 45-45V76c0-24.813-20.187-45-45-45ZM151 61h150v40H151Zm150 0h60v40h-60zm181 375c0 8.271-6.729 15-15 15H45c-8.271 0-15-6.729-15-15V76c0-8.271 6.729-15 15-15h76v55c0 8.284 6.716 15 15 15h240c8.284 0 15-6.716 15-15V61h76c8.271 0 15 6.729 15 15z"></path>
                                                            <path d="M433 193.58V176c0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15v17.58c-17.459 6.192-30 22.865-30 42.42 0 19.555 12.541 36.228 30 42.42V406c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15V278.42c17.459-6.192 30-22.865 30-42.42 0-19.555-12.541-36.228-30-42.42zM418 251c-8.271 0-15-6.729-15-15s6.729-15 15-15 15 6.729 15 15-6.729 15-15 15zM325 303.58V176c0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15v127.58c-17.459 6.192-30 22.865-30 42.42 0 19.555 12.541 36.228 30 42.42V406c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15v-17.58c17.459-6.192 30-22.865 30-42.42 0-19.555-12.541-36.228-30-42.42zM310 361c-8.271 0-15-6.729-15-15s6.729-15 15-15 15 6.729 15 15-6.729 15-15 15zM217 193.58V176c0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15v17.58c-17.459 6.192-30 22.865-30 42.42 0 19.555 12.541 36.228 30 42.42V406c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15V278.42c17.459-6.192 30-22.865 30-42.42 0-19.555-12.541-36.228-30-42.42zM202 251c-8.271 0-15-6.729-15-15s6.729-15 15-15 15 6.729 15 15-6.729 15-15 15zM109 303.58V176c0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15v127.58c-17.459 6.192-30 22.865-30 42.42 0 19.555 12.541 36.228 30 42.42V406c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15v-17.58c17.459-6.192 30-22.865 30-42.42 0-19.555-12.541-36.228-30-42.42zM94 361c-8.271 0-15-6.729-15-15s6.729-15 15-15 15 6.729 15 15-6.729 15-15 15zM898.119 507.606A14.95 14.95 0 0 0 908.725 512a14.95 14.95 0 0 0 10.606-4.394l40-40c5.858-5.857 5.858-15.355 0-21.213-5.857-5.857-15.355-5.857-21.213 0l-14.393 14.394V387c0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15v73.787l-14.394-14.394c-5.857-5.857-15.355-5.857-21.213 0-5.858 5.857-5.858 15.355 0 21.213zM949.544 297.606l14.394-14.393V357c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15v-73.787l14.394 14.394a14.953 14.953 0 0 0 10.606 4.393 14.95 14.95 0 0 0 10.606-4.394c5.858-5.857 5.858-15.355 0-21.213l-40-40c-5.857-5.857-15.355-5.857-21.213 0l-40 40c-5.858 5.857-5.858 15.355 0 21.213 5.858 5.858 15.356 5.858 21.213 0z"></path>
                                                        </svg>
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Equalizer
                                                        </div>
                                                        <p className="chakra-text css-itvw0n">
                                                            Adjust the
                                                            frequencies of your
                                                            audio
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="drop-menu-item">
                                            <Link
                                                to="/NoiseReducer"
                                                onClick={menuHandle}
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <svg
                                                            height="100%"
                                                            width="100%"
                                                            xmlSpace="preserve"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 512 512"
                                                            fill="#319795"
                                                            stroke="#319795"
                                                        >
                                                            <path
                                                                d="M291.25 413.565v25.8c0 24.951-20.299 45.25-45.25 45.25h-80.375c-24.951 0-45.25-20.299-45.25-45.25.528-64.81 11.878-103.767-30.19-105.375-8-.306-14.913 0-26.747 0-17.293 0-31.546 13.247-33.156 30.125H15c-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15h15.125v26.938c0 18.368 14.944 33.313 33.313 33.313H91.88c6.972 34.331 37.387 60.25 73.745 60.25H246c41.493 0 75.25-33.757 75.25-75.25v-25.8zm-231.125 7.488v-53.75a3.317 3.317 0 0 1 3.313-3.313h26.938v60.375H63.438a3.316 3.316 0 0 1-3.313-3.312z"
                                                                style={{
                                                                    opacity: 1,
                                                                }}
                                                            ></path>
                                                            <circle
                                                                cx="305.223"
                                                                cy="206.777"
                                                                r="191.777"
                                                                style={{
                                                                    opacity: 1,
                                                                    fill: 'none',
                                                                    fillOpacity: 1,
                                                                    fillRule:
                                                                        'evenodd',
                                                                    strokeWidth: 30,
                                                                    strokeDasharray:
                                                                        'none',
                                                                    strokeOpacity: 1,
                                                                }}
                                                            ></circle>
                                                            <rect
                                                                width="29.927"
                                                                height="380.317"
                                                                x="291.323"
                                                                y="3.151"
                                                                ry="0"
                                                                style={{
                                                                    fillRule:
                                                                        'evenodd',
                                                                    stroke: 'none',
                                                                    strokeWidth: 30,
                                                                    strokeDasharray:
                                                                        'none',
                                                                    strokeOpacity: 1,
                                                                }}
                                                            ></rect>
                                                            <rect
                                                                width="29.927"
                                                                height="343.347"
                                                                x="201.073"
                                                                y="33.207"
                                                                ry="0"
                                                                style={{
                                                                    fillRule:
                                                                        'evenodd',
                                                                    stroke: 'none',
                                                                    strokeWidth: 30,
                                                                    strokeDasharray:
                                                                        'none',
                                                                    strokeOpacity: 1,
                                                                }}
                                                            ></rect>
                                                            <rect
                                                                width="29.927"
                                                                height="343.347"
                                                                x="381.644"
                                                                y="32.605"
                                                                ry="0"
                                                                style={{
                                                                    fillRule:
                                                                        'evenodd',
                                                                    stroke: 'none',
                                                                    strokeWidth: 30,
                                                                    strokeDasharray:
                                                                        'none',
                                                                    strokeOpacity: 1,
                                                                }}
                                                            ></rect>
                                                            <rect
                                                                width="29.927"
                                                                height="380.317"
                                                                x="191.813"
                                                                y="-497"
                                                                ry="0"
                                                                transform="rotate(90)"
                                                                style={{
                                                                    fillRule:
                                                                        'evenodd',
                                                                    stroke: 'none',
                                                                    strokeWidth: 30,
                                                                    strokeDasharray:
                                                                        'none',
                                                                    strokeOpacity: 1,
                                                                }}
                                                            ></rect>
                                                            <rect
                                                                width="29.927"
                                                                height="342.332"
                                                                x="283.938"
                                                                y="-473.423"
                                                                ry="0"
                                                                transform="rotate(90)"
                                                                style={{
                                                                    fillOpacity: 1,
                                                                    fillRule:
                                                                        'evenodd',
                                                                    stroke: 'none',
                                                                    strokeWidth: 30,
                                                                    strokeDasharray:
                                                                        'none',
                                                                    strokeOpacity: 1,
                                                                }}
                                                            ></rect>
                                                            <rect
                                                                width="29.927"
                                                                height="342.332"
                                                                x="103.005"
                                                                y="-472.295"
                                                                ry="0"
                                                                transform="rotate(90)"
                                                                style={{
                                                                    fillOpacity: 1,
                                                                    fillRule:
                                                                        'evenodd',
                                                                    stroke: 'none',
                                                                    strokeWidth: 30,
                                                                    strokeDasharray:
                                                                        'none',
                                                                    strokeOpacity: 1,
                                                                }}
                                                            ></rect>
                                                        </svg>
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Noise Reducer
                                                        </div>
                                                        <p className="chakra-text css-itvw0n">
                                                            Reduce background
                                                            noise from
                                                            recordings
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="drop-menu-item">
                                            <Link
                                                to="/PitchShifter"
                                                onClick={menuHandle}
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <svg
                                                            height="100%"
                                                            width="100%"
                                                            xmlSpace="preserve"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 512 512"
                                                            fill="#3182CE"
                                                            stroke="#3182CE"
                                                        >
                                                            <path d="M-55 31h-422c-24.813 0-45 20.187-45 45v360c0 24.813 20.187 45 45 45h422c24.813 0 45-20.187 45-45V76c0-24.813-20.187-45-45-45Zm-316 30h150v40h-150Zm150 0h60v40h-60zm181 375c0 8.271-6.729 15-15 15h-422c-8.271 0-15-6.729-15-15V76c0-8.271 6.729-15 15-15h76v55c0 8.284 6.716 15 15 15h240c8.284 0 15-6.716 15-15V61h76c8.271 0 15 6.729 15 15z"></path>
                                                            <path d="M-89 193.58V176c0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15v17.58c-17.459 6.192-30 22.865-30 42.42 0 19.555 12.541 36.228 30 42.42V406c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15V278.42c17.459-6.192 30-22.865 30-42.42 0-19.555-12.541-36.228-30-42.42zM-104 251c-8.271 0-15-6.729-15-15s6.729-15 15-15 15 6.729 15 15-6.729 15-15 15zM-197 303.58V176c0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15v127.58c-17.459 6.192-30 22.865-30 42.42 0 19.555 12.541 36.228 30 42.42V406c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15v-17.58c17.459-6.192 30-22.865 30-42.42 0-19.555-12.541-36.228-30-42.42zM-212 361c-8.271 0-15-6.729-15-15s6.729-15 15-15 15 6.729 15 15-6.729 15-15 15zM-305 193.58V176c0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15v17.58c-17.459 6.192-30 22.865-30 42.42 0 19.555 12.541 36.228 30 42.42V406c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15V278.42c17.459-6.192 30-22.865 30-42.42 0-19.555-12.541-36.228-30-42.42zM-320 251c-8.271 0-15-6.729-15-15s6.729-15 15-15 15 6.729 15 15-6.729 15-15 15zM-413 303.58V176c0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15v127.58c-17.459 6.192-30 22.865-30 42.42 0 19.555 12.541 36.228 30 42.42V406c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15v-17.58c17.459-6.192 30-22.865 30-42.42 0-19.555-12.541-36.228-30-42.42zM-428 361c-8.271 0-15-6.729-15-15s6.729-15 15-15 15 6.729 15 15-6.729 15-15 15zM376.119 507.606A14.95 14.95 0 0 0 386.725 512a14.95 14.95 0 0 0 10.606-4.394l40-40c5.858-5.857 5.858-15.355 0-21.213-5.857-5.857-15.355-5.857-21.213 0l-14.393 14.394V387c0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15v73.787l-14.394-14.394c-5.857-5.857-15.355-5.857-21.213 0-5.858 5.857-5.858 15.355 0 21.213zM427.544 297.606l14.394-14.393V357c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15v-73.787l14.394 14.394A14.953 14.953 0 0 0 496.938 302a14.95 14.95 0 0 0 10.606-4.394c5.858-5.857 5.858-15.355 0-21.213l-40-40c-5.857-5.857-15.355-5.857-21.213 0l-40 40c-5.858 5.857-5.858 15.355 0 21.213 5.858 5.858 15.356 5.858 21.213 0z"></path>
                                                            <path
                                                                d="M371.863 7.286c0-11.656-11.772-19.625-22.594-15.297L129.6 79.857a16.474 16.474 0 0 0-10.356 15.297v239.518a65.47 65.47 0 0 0-32.95-8.866c-36.338 0-65.901 29.563-65.901 65.9 0 36.338 29.563 65.901 65.9 65.901 36.338 0 65.901-29.563 65.901-65.9V194.175l186.719-74.688v127.317a65.47 65.47 0 0 0-32.95-8.866c-36.338 0-65.901 29.563-65.901 65.901 0 36.338 29.563 65.9 65.9 65.9 36.338 0 65.901-29.562 65.901-65.9zM86.293 424.657c-18.168 0-32.95-14.782-32.95-32.95 0-18.17 14.782-32.95 32.95-32.95 18.17 0 32.951 14.78 32.951 32.95 0 18.168-14.782 32.95-32.95 32.95zm65.901-265.97v-52.38L338.913 31.62v52.379zm153.769 178.102c-18.17 0-32.95-14.781-32.95-32.95 0-18.169 14.78-32.95 32.95-32.95 18.168 0 32.95 14.781 32.95 32.95 0 18.169-14.782 32.95-32.95 32.95z"
                                                                transform="translate(-20.393 9.205)"
                                                                style={{
                                                                    strokeWidth: 1.09834,
                                                                }}
                                                            ></path>
                                                        </svg>
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Pitch Shifter
                                                        </div>
                                                        <p className="chakra-text css-itvw0n">
                                                            Change the pitch of
                                                            your audio
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="drop-menu-item">
                                            <Link
                                                to="/Reverb"
                                                onClick={menuHandle}
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <svg
                                                            height="100%"
                                                            width="100%"
                                                            xmlSpace="preserve"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 512 512"
                                                            fill="#00B5D8"
                                                            stroke="#00B5D8"
                                                        >
                                                            <path
                                                                d="M497 110.07H269.719L18.73 45.66a14.994 14.994 0 0 0-12.926 2.676A15.013 15.013 0 0 0 0 60.188v391.625a15.002 15.002 0 0 0 18.73 14.53l250.989-64.41h227.28c8.286 0 15.001-6.718 15.001-15V125.07c0-8.285-6.715-15-15-15zM30 79.523l222.824 57.184v238.586L30 432.477Zm332.012 292.41v-96.398h40.8v96.399zm119.988 0h-49.188V260.536c0-8.281-6.718-15-15-15h-70.8c-8.282 0-15 6.719-15 15v111.399h-49.188V140.07H482z"
                                                                style={{
                                                                    strokeWidth: 1.33333,
                                                                }}
                                                            ></path>
                                                            <path
                                                                d="M204.188 185.344 98.27 162.078a15.016 15.016 0 0 0-12.622 2.961 15.008 15.008 0 0 0-5.597 11.692v158.542a15 15 0 0 0 15 15c1.07 0 2.148-.117 3.218-.351l105.918-23.266a14.996 14.996 0 0 0 11.782-14.648V199.996a15 15 0 0 0-11.781-14.652zm-94.137 10.039 22.957 5.043v111.148l-22.957 5.043zm75.918 104.562-22.961 5.043v-97.972l22.96 5.043z"
                                                                style={{
                                                                    strokeWidth: 1.33333,
                                                                }}
                                                            ></path>
                                                        </svg>
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Reverb
                                                        </div>
                                                        <p className="chakra-text css-itvw0n">
                                                            Increase the room
                                                            size of your audio
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="drop-menu-item">
                                            <Link
                                                to="/reverseAudio"
                                                onClick={menuHandle}
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <svg
                                                            height="100%"
                                                            width="100%"
                                                            xmlSpace="preserve"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 512 512"
                                                            fill="#805AD5"
                                                            stroke="#805AD5"
                                                        >
                                                            <path d="M256 0C114.51 0 0 114.497 0 256c0 141.49 114.495 256 256 256 141.491 0 256-114.497 256-256C512 114.509 397.503 0 256 0Zm0 478.609c-122.746 0-222.609-99.862-222.609-222.609 0-122.747 99.861-222.609 222.609-222.609S478.609 133.254 478.609 256c0 122.746-99.863 222.609-222.609 222.609z"></path>
                                                            <path d="m146.753 270.452 155.778 90.01c11.128 6.426 25.048-1.63 25.048-14.456v-180.02c0-12.922-14.01-20.833-25.048-14.456l-155.778 90.01c-11.116 6.424-11.102 22.496 0 28.912zm147.435-75.537v122.162l-105.711-61.08Z"></path>
                                                        </svg>
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Reverse Audio
                                                        </div>
                                                        <p className="chakra-text css-itvw0n">
                                                            Reverse an audio
                                                            file and make it
                                                            play backwards
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="drop-menu-item">
                                            <Link
                                                to="/stereoPanner"
                                                onClick={menuHandle}
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <svg
                                                            height="100%"
                                                            width="100%"
                                                            xmlSpace="preserve"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 512 512"
                                                            fill="#D53F8C"
                                                            stroke="#D53F8C"
                                                        >
                                                            <defs>
                                                                <path
                                                                    id="stereo-panner_svg__a"
                                                                    d="M1494.824 12.728h239.002v241.831h-239.002z"
                                                                ></path>
                                                            </defs>
                                                            <g
                                                                style={{
                                                                    strokeWidth: 1.33526,
                                                                }}
                                                            >
                                                                <path
                                                                    d="M1385.333 144C1236.823 144 1116 264.823 1116 413.333c0 148.51 120.823 269.334 269.333 269.334 148.51 0 269.334-120.823 269.334-269.334 0-148.51-120.823-269.333-269.334-269.333Zm0 498.667c-126.453 0-229.333-102.88-229.333-229.334C1156 286.88 1258.88 184 1385.333 184s229.334 102.88 229.334 229.333-102.88 229.334-229.334 229.334zM1385.333 40c80.49 0 156.162 31.344 213.073 88.255l28.287-28.281C1562.224 35.505 1476.505 0 1385.333 0c-91.172 0-176.89 35.505-241.359 99.974l28.286 28.281C1229.172 71.344 1304.844 40 1385.333 40Zm0 0"
                                                                    transform="matrix(.74892 0 0 .74892 -781.87 0)"
                                                                    style={{
                                                                        strokeWidth: 1.78035,
                                                                    }}
                                                                ></path>
                                                                <path
                                                                    transform="scale(-.74892 .74892) rotate(45 522 1260.22)"
                                                                    d="M-956.641 1251.918h186.668v39.866h-186.668z"
                                                                    style={{
                                                                        stroke: 'none',
                                                                    }}
                                                                ></path>
                                                                <text
                                                                    xmlSpace="preserve"
                                                                    transform="matrix(1 0 0 1 -1056.143 10.305)"
                                                                    style={{
                                                                        fontStyle:
                                                                            'normal',
                                                                        fontVariant:
                                                                            'normal',
                                                                        fontWeight: 700,
                                                                        fontStretch:
                                                                            'normal',
                                                                        fontSize: 96,
                                                                        lineHeight: 1.25,
                                                                        fontFamily:
                                                                            'Helvetica, sans-serif',
                                                                        whiteSpace:
                                                                            'pre',
                                                                        display:
                                                                            'inline',
                                                                    }}
                                                                >
                                                                    <tspan
                                                                        x="1067"
                                                                        y="169.384"
                                                                    >
                                                                        <tspan>
                                                                            L
                                                                        </tspan>
                                                                    </tspan>
                                                                </text>
                                                                <text
                                                                    xmlSpace="preserve"
                                                                    transform="matrix(1 0 0 1 -1071.014 79.377)"
                                                                    style={{
                                                                        fontStyle:
                                                                            'normal',
                                                                        fontVariant:
                                                                            'normal',
                                                                        fontWeight: 700,
                                                                        fontStretch:
                                                                            'normal',
                                                                        fontSize: 96,
                                                                        lineHeight: 1.25,
                                                                        fontFamily:
                                                                            'Helvetica, sans-serif',
                                                                        whiteSpace:
                                                                            'pre',
                                                                        display:
                                                                            'inline',
                                                                    }}
                                                                >
                                                                    <tspan
                                                                        x="1494.824"
                                                                        y="100.312"
                                                                    >
                                                                        R
                                                                    </tspan>
                                                                </text>
                                                            </g>
                                                        </svg>
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Stereo Panner
                                                        </div>
                                                        <p className="chakra-text css-itvw0n">
                                                            Pan the audio to
                                                            left or right
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="drop-menu-item">
                                            <Link
                                                to="/tempoChanger"
                                                onClick={menuHandle}
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <svg
                                                            height="100%"
                                                            width="100%"
                                                            xmlSpace="preserve"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 512 512"
                                                            fill="#E53E3E"
                                                            stroke="#E53E3E"
                                                        >
                                                            <path d="M256 0C114.51 0 0 114.497 0 256c0 141.49 114.495 256 256 256 141.491 0 256-114.497 256-256C512 114.509 397.503 0 256 0Zm0 478.609c-122.746 0-222.609-99.862-222.609-222.609 0-122.747 99.861-222.609 222.609-222.609S478.609 133.254 478.609 256c0 122.746-99.863 222.609-222.609 222.609z"></path>
                                                            <path d="m416.8 241.548-155.778-90.01c-11.128-6.426-25.048 1.63-25.048 14.456v70.537l43.487 20.153-43.487 19.445v69.885c0 12.922 14.01 20.833 25.048 14.456L416.8 270.46c11.116-6.424 11.102-22.496 0-28.912zm-147.435 75.537V194.923l105.71 61.08z"></path>
                                                            <path d="m305.695 241.548-155.778-90.01c-11.128-6.426-25.048 1.63-25.048 14.456v180.02c0 12.922 14.01 20.833 25.048 14.456l155.778-90.01c11.116-6.424 11.102-22.496 0-28.912zM158.26 317.085V194.923l105.71 61.08z"></path>
                                                        </svg>
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Tempo Changer
                                                        </div>
                                                        <p className="chakra-text css-itvw0n">
                                                            Make an audio file
                                                            play faster or
                                                            slower
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="drop-menu-item">
                                            <Link
                                                to="/vocalRemover"
                                                onClick={menuHandle}
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <svg
                                                            height="100%"
                                                            width="100%"
                                                            xmlSpace="preserve"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 512 512"
                                                            fill="#D69E2E"
                                                            stroke="#D69E2E"
                                                        >
                                                            <path d="M265 160h-15V65c0-35.841-29.159-65-65-65h-60C89.159 0 60 29.159 60 65v95H45c-24.813 0-45 20.187-45 45v40c0 62.118 45.549 113.791 105 123.393V420H85c-35.841 0-65 29.159-65 65v12c0 8.284 6.716 15 15 15h240c8.284 0 15-6.716 15-15v-12c0-35.841-29.159-65-65-65h-20v-51.607c59.451-9.602 105-61.275 105-123.393v-40c0-24.813-20.187-45-45-45zM125 30h60c19.299 0 35 15.701 35 35v15h-25c-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15h25v30h-25c-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15h25v30h-25c-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15h25v15c0 19.299-15.701 35-35 35h-60c-19.299 0-35-15.701-35-35v-15h25c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15H90v-30h25c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15H90v-30h25c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15H90V65c0-19.299 15.701-35 35-35Zm134.873 452H50.127c1.527-17.899 16.585-32 34.873-32h140c18.288 0 33.346 14.101 34.873 32zM135 420v-50h40v50zm145-175c0 52.383-42.617 95-95 95h-60c-52.383 0-95-42.617-95-95v-40c0-8.271 6.729-15 15-15h15v55c0 35.841 29.159 65 65 65h60c35.841 0 65-29.159 65-65v-55h15c8.271 0 15 6.729 15 15zM407 0c-57.897 0-105 47.103-105 105s47.103 105 105 105 105-47.103 105-105S464.897 0 407 0Zm0 30c15.264 0 29.47 4.594 41.33 12.457L344.458 146.33C336.594 134.47 332 120.264 332 105c0-41.355 33.645-75 75-75Zm0 150c-15.264 0-29.47-4.594-41.33-12.457L469.542 63.67C477.406 75.53 482 89.736 482 105c0 41.355-33.645 75-75 75z"></path>
                                                        </svg>
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Vocal Remover
                                                        </div>
                                                        <p className="chakra-text css-itvw0n">
                                                            Remove the vocals
                                                            from a song leaving
                                                            only the
                                                            instrumental
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="drop-menu-item">
                                            <Link
                                                to="/volumeChanger"
                                                onClick={menuHandle}
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <svg
                                                            height="100%"
                                                            width="100%"
                                                            xmlSpace="preserve"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 512 512"
                                                            fill="#38A169"
                                                            stroke="#38A169"
                                                        >
                                                            <path d="m224.511 85.363-113.319 87.168H50.087C22.469 172.531 0 195 0 222.618V289.4c0 27.618 22.469 50.087 50.087 50.087h61.105l113.319 87.168c21.916 16.859 53.75 1.274 53.75-26.466v-288.36c0-27.695-31.809-43.348-53.75-26.466zM100.174 306.096H50.087c-9.206 0-16.696-7.49-16.696-16.696v-66.783c0-9.206 7.49-16.696 16.696-16.696h50.087zm144.696 94.093L133.566 314.57V197.447l111.304-85.619ZM438.649 78.916c-6.52-6.52-17.092-6.52-23.611 0-6.52 6.52-6.52 17.091 0 23.611 40.995 40.995 63.57 95.499 63.57 153.473 0 57.974-22.576 112.479-63.57 153.473-6.52 6.52-6.52 17.091 0 23.611 6.519 6.52 17.091 6.52 23.611 0C485.95 385.783 512 322.894 512 256s-26.05-129.783-73.351-177.084Z"></path>
                                                            <path d="M391.427 126.139c-6.518-6.519-17.09-6.52-23.611 0-6.52 6.52-6.52 17.091 0 23.611 58.586 58.586 58.586 153.914 0 212.501-6.52 6.52-6.52 17.091 0 23.611 6.519 6.519 17.091 6.52 23.611 0 71.606-71.605 71.606-188.118 0-259.723z"></path>
                                                            <path d="M344.204 173.361c-6.519-6.52-17.091-6.52-23.611 0s-6.52 17.091 0 23.611c32.548 32.549 32.548 85.507 0 118.056-6.52 6.52-6.52 17.091 0 23.611 6.519 6.52 17.091 6.521 23.611 0 45.567-45.567 45.567-119.71 0-165.278z"></path>
                                                        </svg>
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Volume Changer
                                                        </div>
                                                        <p className="chakra-text css-itvw0n">
                                                            Make your audio
                                                            louder or quieter
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="drop-menu-item">
                                            <Link
                                                target="_blank"
                                                rel="noreferrer"
                                                to="https://chat.aicte-india.org"
                                                // onClick={menuHandle}
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <svg
                                                            viewBox="0 0 1024 1024"
                                                            height="100%"
                                                            width="100%"
                                                            fill="#DD6B20"
                                                        >
                                                            <g>
                                                                <g>
                                                                    <path
                                                                        d="M859.694,253.888H714.232V147.215c0-69.513-56.553-126.065-126.064-126.065H161.483
    c-69.512,0-126.065,56.553-126.065,126.065v193.948c0,66.252,51.369,120.729,116.367,125.697v196.669l155.159-155.157v65.53
    c0,69.512,56.552,126.064,126.064,126.064h240.083l196.299,196.301V699.596c65.001-4.968,116.369-59.446,116.369-125.695V379.953
    C985.76,310.44,929.206,253.888,859.694,253.888z M306.944,379.953v46.134l-96.975,96.974V409.045h-48.486
    c-37.429,0-67.882-30.452-67.882-67.882V147.215c0-37.429,30.453-67.88,67.882-67.88h426.685c37.431,0,67.882,30.451,67.882,67.88
    v106.673H433.009C363.496,253.888,306.944,310.44,306.944,379.953z M927.576,573.9c0,37.43-30.452,67.881-67.882,67.881h-48.487
    v114.015L697.19,641.781H433.009c-37.43,0-67.882-30.451-67.882-67.881V379.953c0-37.431,30.452-67.883,67.882-67.883h426.686
    c37.43,0,67.882,30.452,67.882,67.883V573.9z"
                                                                    ></path>
                                                                    <rect
                                                                        x="452.405"
                                                                        y="389.649"
                                                                        width="387.893"
                                                                        height="58.185"
                                                                    ></rect>
                                                                    <rect
                                                                        x="452.405"
                                                                        y="506.019"
                                                                        width="387.893"
                                                                        height="58.184"
                                                                    ></rect>
                                                                </g>
                                                            </g>
                                                        </svg>
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Speech Messenger
                                                        </div>
                                                        <p className="chakra-text css-itvw0n">
                                                            Communicate with
                                                            your native language
                                                            (text, audio or
                                                            video supported)
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </li>

                            <li>
                                <Link
                                    to={undefined}
                                    title="File"
                                    className="meetingMenu dropdown-toggle"
                                    id="dropdownMenuButton6"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    File
                                    <svg
                                        data-v-7e3b073a=""
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        role="Image"
                                        aria-hidden="true"
                                        className="v-icon__svg"
                                        style={{
                                            fontSize: 14,
                                            height: 14,
                                            width: 14,
                                        }}
                                    >
                                        <path
                                            data-v-7e3b073a=""
                                            d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
                                        ></path>
                                    </svg>
                                </Link>
                                <div
                                    className="navDropDown fileDropDown  dropdown-menu"
                                    aria-labelledby="dropdownMenuButton6"
                                >
                                    <ul>
                                        <li className="drop-menu-item">
                                            <Link
                                                target="_blank"
                                                rel="noreferrer"
                                                to="https://anuvadini.aicte-india.org/mkb100/"
                                                onClick={menuHandle}
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <Image
                                                            src="https://anuvadini.aicte-india.org/images/mkb.png"
                                                            width={50}
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Mann ki baat
                                                        </div>
                                                        <p className="chakra-text css-itvw0n">
                                                            (100th episode
                                                            celebration) <br />
                                                            Citizen feedback
                                                            Form
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </li>

                            <li>
                                <Link
                                    to={undefined}
                                    title="File"
                                    className="meetingMenu dropdown-toggle"
                                    id="dropdownMenuButton7"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    Education
                                    <svg
                                        data-v-7e3b073a=""
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        role="Image"
                                        aria-hidden="true"
                                        className="v-icon__svg"
                                        style={{
                                            fontSize: 14,
                                            height: 14,
                                            width: 14,
                                        }}
                                    >
                                        <path
                                            data-v-7e3b073a=""
                                            d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
                                        ></path>
                                    </svg>
                                </Link>
                                <div
                                    className="navDropDown educationDropDown  dropdown-menu"
                                    aria-labelledby="dropdownMenuButton7"
                                >
                                    <ul>
                                        <li className="drop-menu-item">
                                            <Link
                                                target="_blank"
                                                rel="noreferrer"
                                                to="https://anuvadini.aicte-india.org/core-engg"
                                                onClick={menuHandle}
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <Image
                                                            src={coreEngg}
                                                            width={50}
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Core Engineering
                                                            Generative AI
                                                        </div>
                                                        <p className="chakra-text css-itvw0n"></p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="drop-menu-item">
                                            <Link
                                                to={undefined}
                                                onClick={menuHandle}
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <svg
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <g
                                                                id="SVGRepo_bgCarrier"
                                                                strokeWidth="0"
                                                            ></g>
                                                            <g
                                                                id="SVGRepo_tracerCarrier"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            ></g>
                                                            <g id="SVGRepo_iconCarrier">
                                                                {' '}
                                                                <path
                                                                    d="M9 13H13M9 17H15M13.0714 2.52927V6.83334C13.0714 7.93791 13.9668 8.83334 15.0714 8.83334H19.3494M13.0714 2.52927C12.7307 2.5095 12.3738 2.5 12 2.5C6.26471 2.5 4.5 4.73529 4.5 12C4.5 19.2647 6.26471 21.5 12 21.5C17.7353 21.5 19.5 19.2647 19.5 12C19.5 10.8146 19.453 9.76307 19.3494 8.83334M13.0714 2.52927L19.3494 8.83334"
                                                                    stroke="#01d5f5"
                                                                    strokeWidth="1.5"
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                ></path>{' '}
                                                            </g>
                                                        </svg>
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Killer - CV
                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                            <li>
                                <Link
                                    to={undefined}
                                    title="Image"
                                    className="imageMenu dropdown-toggle"
                                    id="dropdownMenuButton3"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    Image
                                    <svg
                                        data-v-7e3b073a=""
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        role="Image"
                                        aria-hidden="true"
                                        className="v-icon__svg"
                                        style={{
                                            fontSize: 14,
                                            height: 14,
                                            width: 14,
                                        }}
                                    >
                                        <path
                                            data-v-7e3b073a=""
                                            d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
                                        ></path>
                                    </svg>
                                </Link>
                                <div
                                    className="navDropDown imageDrop dropdown-menu"
                                    aria-labelledby="dropdownMenuButton3"
                                >
                                    <ul>
                                        <li className="drop-menu-item">
                                            <Link
                                                target="_blank"
                                                rel="noreferrer"
                                                to="https://anuvadini.aicte-india.org/speech-to-image-22/"
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <img
                                                            src={image22}
                                                            alt=""
                                                            width={50}
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            SpeakPic
                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="drop-menu-item">
                                            <a
                                                href="https://anuvadini.aicte-india.org/image-23/"
                                                onClick={menuHandle}
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <img
                                                            src={image23}
                                                            alt=""
                                                            width={50}
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            JaduiDarpan
                                                        </div>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                        <li className="drop-menu-item">
                                            <Link
                                                target="_blank"
                                                rel="noreferrer"
                                                to="/HandwrittenAI"
                                                onClick={menuHandle}
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <img
                                                            src={image25}
                                                            width={50}
                                                            alt="handwritten ai"
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Handwritten AI
                                                        </div>
                                                        <p className="chakra-text css-itvw0n"></p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="drop-menu-item">
                                            <Link
                                                to="https://anuvadini.aicte-india.org/image-editor/ImageBackgroundRemover"
                                                onClick={menuHandle}
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <svg
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <g
                                                                id="SVGRepo_bgCarrier"
                                                                strokeWidth="0"
                                                            ></g>
                                                            <g
                                                                id="SVGRepo_tracerCarrier"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            ></g>
                                                            <g id="SVGRepo_iconCarrier">
                                                                {' '}
                                                                <path
                                                                    d="M12 17C13.6569 17 15 15.6569 15 14C15 12.3431 13.6569 11 12 11C10.3431 11 9 12.3431 9 14"
                                                                    stroke="#38A169"
                                                                    strokeWidth="1.5"
                                                                    strokeLinecap="round"
                                                                ></path>{' '}
                                                                <path
                                                                    d="M18 6.00002V6.75002H18.75V6.00002H18ZM15.7172 2.32614L15.6111 1.58368L15.7172 2.32614ZM4.91959 3.86865L4.81353 3.12619H4.81353L4.91959 3.86865ZM5.07107 6.75002H18V5.25002H5.07107V6.75002ZM18.75 6.00002V4.30604H17.25V6.00002H18.75ZM15.6111 1.58368L4.81353 3.12619L5.02566 4.61111L15.8232 3.0686L15.6111 1.58368ZM4.81353 3.12619C3.91638 3.25435 3.25 4.0227 3.25 4.92895H4.75C4.75 4.76917 4.86749 4.63371 5.02566 4.61111L4.81353 3.12619ZM18.75 4.30604C18.75 2.63253 17.2678 1.34701 15.6111 1.58368L15.8232 3.0686C16.5763 2.96103 17.25 3.54535 17.25 4.30604H18.75ZM5.07107 5.25002C4.89375 5.25002 4.75 5.10627 4.75 4.92895H3.25C3.25 5.9347 4.06532 6.75002 5.07107 6.75002V5.25002Z"
                                                                    fill="#38A169"
                                                                ></path>{' '}
                                                                <path
                                                                    d="M4 6V19C4 20.6569 5.34315 22 7 22H17C18.6569 22 20 20.6569 20 19V14M4 6V5M4 6H17C18.6569 6 20 7.34315 20 9V10"
                                                                    stroke="#38A169"
                                                                    strokeWidth="1.5"
                                                                    strokeLinecap="round"
                                                                ></path>{' '}
                                                            </g>
                                                        </svg>
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Image Background
                                                            Remover
                                                        </div>
                                                        <p className="chakra-text css-itvw0n"></p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="drop-menu-item">
                                            <Link
                                                to="/RemoveUnwantedObjects"
                                                onClick={menuHandle}
                                                style={{
                                                    opacity: 0.3,
                                                    filter: 'grayscale(100%)',
                                                }}
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <svg
                                                            fill="#D69E2E"
                                                            viewBox="0 0 1920 1920"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <g
                                                                id="SVGRepo_bgCarrier"
                                                                strokeWidth="0"
                                                            ></g>
                                                            <g
                                                                id="SVGRepo_tracerCarrier"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            ></g>
                                                            <g id="SVGRepo_iconCarrier">
                                                                {' '}
                                                                <path
                                                                    d="M0 1920h1242.353V677.647H0V1920ZM1129.412 790.588v1016.47H112.942V790.589h1016.47Zm451.764-451.764v1242.352h-225.882v-112.94h112.941V451.764H451.765v112.94H338.824V338.825h1242.352ZM1920.034-.011v1242.353h-225.882V1129.4h112.94V112.93H790.623v112.94H677.681V-.01h1242.353ZM338.824 1355.294h564.705v-112.941H338.824v112.941Z"
                                                                    fillRule="evenodd"
                                                                ></path>{' '}
                                                            </g>
                                                        </svg>
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Remove Unwanted
                                                            Objects
                                                        </div>
                                                        <p className="chakra-text css-itvw0n"></p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="drop-menu-item">
                                            <Link
                                                onClick={menuHandle}
                                                style={{
                                                    opacity: 0.3,
                                                    filter: 'grayscale(100%)',
                                                }}
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <img
                                                            src={FaceCutout}
                                                            alt=""
                                                            width={50}
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Face Cutout
                                                        </div>
                                                        <p className="chakra-text css-itvw0n"></p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="drop-menu-item">
                                            <Link
                                                to="https://anuvadini.aicte-india.org/image-editor/graytocolor"
                                                onClick={menuHandle}
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <img
                                                            src={
                                                                SketchRendering
                                                            }
                                                            alt=""
                                                            width={50}
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Sketch Rendering
                                                        </div>
                                                        <p className="chakra-text css-itvw0n"></p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        {/* <li className="drop-menu-item">
                      <Link
                        onClick={menuHandle}
                        style={{ opacity: 0.3, filter: "grayscale(100%)" }}
                      >
                        <div className="css-hboir5">
                          <div className="css-1hnxo7a">
                            <img src={CreativeFusion} alt="" width={50} />
                          </div>
                          <div className="css-195k0gj">
                            <div className="chakra-heading css-9f6g39">
                              Creative Fusion
                            </div>
                            <p className="chakra-text css-itvw0n"></p>
                          </div>
                        </div>
                      </Link>
                    </li> */}
                                        <li className="drop-menu-item">
                                            <Link
                                                to="https://anuvadini.aicte-india.org/image-editor/photoToSketch"
                                                onClick={menuHandle}
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <img
                                                            src={PhotoToSketch}
                                                            alt=""
                                                            width={50}
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Photo To Sketch
                                                        </div>
                                                        <p className="chakra-text css-itvw0n"></p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        {/* <li className="drop-menu-item">
                      <Link
                        onClick={menuHandle}
                        style={{ opacity: 0.3, filter: "grayscale(100%)" }}
                      >
                        <div className="css-hboir5">
                          <div className="css-1hnxo7a">
                            <img src={AISupermodel} alt="" width={50} />
                          </div>
                          <div className="css-195k0gj">
                            <div className="chakra-heading css-9f6g39">
                              AI Supermodel
                            </div>
                            <p className="chakra-text css-itvw0n"></p>
                          </div>
                        </div>
                      </Link>
                    </li> */}
                                        {/* <li className="drop-menu-item">
                      <Link
                        onClick={menuHandle}
                        style={{ opacity: 0.3, filter: "grayscale(100%)" }}
                      >
                        <div className="css-hboir5">
                          <div className="css-1hnxo7a">
                            <img src={AIImageGeneration} alt="" width={50} />
                          </div>
                          <div className="css-195k0gj">
                            <div className="chakra-heading css-9f6g39">
                              AI Image Generation
                            </div>
                            <p className="chakra-text css-itvw0n"></p>
                          </div>
                        </div>
                      </Link>
                    </li> */}
                                        <li className="drop-menu-item">
                                            <Link
                                                onClick={menuHandle}
                                                style={{
                                                    opacity: 0.3,
                                                    filter: 'grayscale(100%)',
                                                }}
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <img
                                                            src={ImageVariation}
                                                            alt=""
                                                            width={50}
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Image Variation
                                                        </div>
                                                        <p className="chakra-text css-itvw0n"></p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        {/* <li className="drop-menu-item">
                    <Link
                        onClick={menuHandle}
                        style={{ opacity: 0.3, filter: "grayscale(100%)" }}
                    >
                        <div className="css-hboir5">
                        <div className="css-1hnxo7a">
                            <img src={BackgroundDiffusion} alt="" width={50} />
                        </div>
                        <div className="css-195k0gj">
                            <div className="chakra-heading css-9f6g39">
                        Background Diffusion
                            </div>
                            <p className="chakra-text css-itvw0n"></p>
                        </div>
                        </div>
                    </Link>
                    </li> */}
                                        <li className="drop-menu-item">
                                            <Link
                                                onClick={menuHandle}
                                                style={{
                                                    opacity: 0.3,
                                                    filter: 'grayscale(100%)',
                                                }}
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <img
                                                            src={TextEffects}
                                                            alt=""
                                                            width={50}
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Text Effects
                                                        </div>
                                                        <p className="chakra-text css-itvw0n"></p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="drop-menu-item">
                                            <Link
                                                onClick={menuHandle}
                                                to="https://anuvadini.aicte-india.org/image-editor/hdUpscaler"
                                                target="_blank"
                                                rel="noreferrer"
                                                // style={{ opacity: 0.3, filter: "grayscale(100%)" }}
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <img
                                                            src={HDUpscaler}
                                                            alt=""
                                                            width={50}
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            HD Upscaler
                                                        </div>
                                                        <p className="chakra-text css-itvw0n"></p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="drop-menu-item">
                                            <Link
                                                onClick={menuHandle}
                                                style={{
                                                    opacity: 0.3,
                                                    filter: 'grayscale(100%)',
                                                }}
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <img
                                                            src={EraseReplace}
                                                            alt=""
                                                            width={50}
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Erase & Replace
                                                        </div>
                                                        <p className="chakra-text css-itvw0n"></p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="drop-menu-item">
                                            <Link
                                                onClick={menuHandle}
                                                style={{
                                                    opacity: 0.3,
                                                    filter: 'grayscale(100%)',
                                                }}
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <img
                                                            src={Outpainting}
                                                            alt=""
                                                            width={50}
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Outpainting
                                                        </div>
                                                        <p className="chakra-text css-itvw0n"></p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="drop-menu-item">
                                            <Link
                                                onClick={menuHandle}
                                                style={{
                                                    opacity: 0.3,
                                                    filter: 'grayscale(100%)',
                                                }}
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <img
                                                            src={Relight}
                                                            alt=""
                                                            width={50}
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Relight
                                                        </div>
                                                        <p className="chakra-text css-itvw0n"></p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="drop-menu-item">
                                            <Link
                                                onClick={menuHandle}
                                                style={{
                                                    opacity: 0.3,
                                                    filter: 'grayscale(100%)',
                                                }}
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <img
                                                            src={ImagetoVideo}
                                                            alt=""
                                                            width={50}
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Image to Video
                                                        </div>
                                                        <p className="chakra-text css-itvw0n"></p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>

                                        <li className="drop-menu-item">
                                            <Link
                                                onClick={menuHandle}
                                                style={{
                                                    opacity: 0.3,
                                                    filter: 'grayscale(100%)',
                                                }}
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <img
                                                            src={TexttoVideo}
                                                            alt=""
                                                            width={50}
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Text to Video
                                                        </div>
                                                        <p className="chakra-text css-itvw0n"></p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </li>

                            <li>
                                <Link
                                    to={undefined}
                                    title="Image"
                                    className="pdfMenu dropdown-toggle"
                                    id="dropdownMenuButtonPDF"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    PDF
                                    <svg
                                        data-v-7e3b073a=""
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        role="Image"
                                        aria-hidden="true"
                                        className="v-icon__svg"
                                        style={{
                                            fontSize: 14,
                                            height: 14,
                                            width: 14,
                                        }}
                                    >
                                        <path
                                            data-v-7e3b073a=""
                                            d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
                                        ></path>
                                    </svg>
                                </Link>
                                <div
                                    className="navDropDown pdfDrop dropdown-menu"
                                    aria-labelledby="dropdownMenuButtonPDF"
                                >
                                    <ul>
                                        <li className="drop-menu-item">
                                            <a
                                                href="https://anuvadini.aicte-india.org/pdf/pdfeditor"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <img
                                                            src={merge}
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Merge PDF
                                                        </div>
                                                        <p className="chakra-text css-itvw0n"></p>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                        <li className="drop-menu-item ">
                                            <a
                                                href="https://anuvadini.aicte-india.org/pdf/splitPDF"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <img
                                                            src={Split}
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Split PDF
                                                        </div>
                                                        <p className="chakra-text css-itvw0n"></p>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                        <li className="drop-menu-item ">
                                            <a
                                                href="https://anuvadini.aicte-india.org/pdf/pdfcompress"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <img
                                                            src={compress}
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Compress PDF
                                                        </div>
                                                        <p className="chakra-text css-itvw0n"></p>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                        <li className="drop-menu-item ">
                                            <a
                                                href="https://anuvadini.aicte-india.org/pdf/pdfpagenum"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                <div className="css-hboir5">
                                                    <div
                                                        className="css-1hnxo7a"
                                                        style={{ width: 75 }}
                                                    >
                                                        <img
                                                            src={pagenum}
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Add page numbers
                                                        </div>
                                                        <p className="chakra-text css-itvw0n"></p>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                        <li className="drop-menu-item ">
                                            <a
                                                href="https://anuvadini.aicte-india.org/pdf/Pdftoimages"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                <div className="css-hboir5">
                                                    <div
                                                        className="css-1hnxo7a"
                                                        style={{ width: 75 }}
                                                    >
                                                        <img
                                                            src={PdftoImages}
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            PDF to images
                                                        </div>
                                                        <p className="chakra-text css-itvw0n"></p>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                        <li className="drop-menu-item  ">
                                            <a
                                                href="https://anuvadini.aicte-india.org/pdf/ImagestoPdf"
                                                target="_blank"
                                                rel="noreferrer"
                                                style={{
                                                    opacity: 0.3,
                                                    filter: 'grayscale(100%)',
                                                }}
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <img
                                                            src={ImagestoPdf}
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Images to PDF
                                                        </div>
                                                        <p className="chakra-text css-itvw0n"></p>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                        <li className="drop-menu-item ">
                                            <a
                                                href="https://anuvadini.aicte-india.org/pdf/ProtectPdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                <div className="css-hboir5">
                                                    <div
                                                        className="css-1hnxo7a"
                                                        style={{ width: 75 }}
                                                    >
                                                        <img
                                                            src={ProtectPdf}
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Protect PDF
                                                        </div>
                                                        <p className="chakra-text css-itvw0n"></p>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                        <li className="drop-menu-item ">
                                            <a
                                                href="https://anuvadini.aicte-india.org/pdf/UnlockPDF"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                <div className="css-hboir5">
                                                    <div
                                                        className="css-1hnxo7a"
                                                        style={{ width: 75 }}
                                                    >
                                                        <img
                                                            src={UnlockPdf}
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Unlock PDF
                                                        </div>
                                                        <p className="chakra-text css-itvw0n"></p>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                        <li className="drop-menu-item ">
                                            <a
                                                href="https://anuvadini.aicte-india.org/pdf/TxttoPdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <img
                                                            src={TxttoPdf}
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Txt to PDF
                                                        </div>
                                                        <p className="chakra-text css-itvw0n"></p>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                        <li className="drop-menu-item ">
                                            <a
                                                href="https://anuvadini.aicte-india.org/pdf/DocxtoPDF"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <img
                                                            src={DocxtoPdf}
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Docx to PDF
                                                        </div>
                                                        <p className="chakra-text css-itvw0n"></p>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                        <li className="drop-menu-item ">
                                            <a
                                                href="https://anuvadini.aicte-india.org/pdf/PpttoPdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                <div className="css-hboir5">
                                                    <div className="css-1hnxo7a">
                                                        <img
                                                            src={PpttoPdf}
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            PPT to PDF
                                                        </div>
                                                        <p className="chakra-text css-itvw0n"></p>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>

                                        <li className="drop-menu-item ">
                                            <a
                                                href="https://anuvadini.aicte-india.org/pdf/ExceltoPdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                <div className="css-hboir5">
                                                    <div
                                                        className="css-1hnxo7a"
                                                        style={{ width: 75 }}
                                                    >
                                                        <img
                                                            src={ExceltoPdf}
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Excel to PDF{' '}
                                                        </div>
                                                        <p className="chakra-text css-itvw0n"></p>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                        <li className="drop-menu-item ">
                                            <a
                                                href="https://anuvadini.aicte-india.org/pdf/PdftoTxt"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                <div className="css-hboir5">
                                                    <div
                                                        className="css-1hnxo7a"
                                                        style={{ width: 75 }}
                                                    >
                                                        <img
                                                            src={PdftoTxt}
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            {' '}
                                                            PDF to Text
                                                        </div>
                                                        <p className="chakra-text css-itvw0n"></p>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                        <li className="drop-menu-item ">
                                            <a href="https://anuvadini.aicte-india.org/pdf/PdftoDocx">
                                                <div className="css-hboir5">
                                                    <div
                                                        className="css-1hnxo7a"
                                                        style={{ width: 75 }}
                                                    >
                                                        <img
                                                            src={Pdfword}
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            PDF to Docx{' '}
                                                        </div>
                                                        <p className="chakra-text css-itvw0n"></p>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                        {/* <li className="drop-menu-item ">
                                        <a href="https://anuvadini.aicte-india.org/pdf/ViewasPdf" target='_blank'>
                                            <div className="css-hboir5">
                                                <div className="css-1hnxo7a" style={{ width: 75 }}>
                                                    <img src={viewPdf} alt="" />
                                                </div>
                                                <div className="css-195k0gj">
                                                    <div className="chakra-heading css-9f6g39"> View As PDF</div>
                                                    <p className="chakra-text css-itvw0n"></p>
                                                </div>
                                            </div>
                                        </a>
                                    </li> */}
                                        {/* <li className="drop-menu-item ">
                                        <a href="https://anuvadini.aicte-india.org/pdf/WeboptimizePdf" target='_blank'>
                                            <div className="css-hboir5">
                                                <div className="css-1hnxo7a" style={{ width: 75 }}>
                                                    <img src={web} alt="" />
                                                </div>
                                                <div className="css-195k0gj">
                                                    <div className="chakra-heading css-9f6g39">Web optimize PDF</div>
                                                    <p className="chakra-text css-itvw0n"></p>
                                                </div>
                                            </div>
                                        </a>
                                    </li> */}
                                        <li className="drop-menu-item ">
                                            <a
                                                href="https://anuvadini.aicte-india.org/pdf/JpgtoPdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                <div className="css-hboir5">
                                                    <div
                                                        className="css-1hnxo7a"
                                                        style={{ width: 75 }}
                                                    >
                                                        <img
                                                            src={JpgtoPdf}
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            JPG to PDF
                                                        </div>
                                                        <p className="chakra-text css-itvw0n"></p>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                        <li className="drop-menu-item ">
                                            <a
                                                href="https://anuvadini.aicte-india.org/pdf/CreatePdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                <div className="css-hboir5">
                                                    <div
                                                        className="css-1hnxo7a"
                                                        style={{ width: 75 }}
                                                    >
                                                        <img
                                                            src={CreatePdf}
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Create PDF
                                                        </div>
                                                        <p className="chakra-text css-itvw0n"></p>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                        <li className="drop-menu-item ">
                                            <a
                                                href="https://anuvadini.aicte-india.org/pdf/AddWatermark"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                <div className="css-hboir5">
                                                    <div
                                                        className="css-1hnxo7a"
                                                        style={{ width: 75 }}
                                                    >
                                                        <img
                                                            src={watermark}
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Add watermark
                                                        </div>
                                                        <p className="chakra-text css-itvw0n"></p>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>

                                        <li className="drop-menu-item ">
                                            <a
                                                href="https://anuvadini.aicte-india.org/pdf/ImagesfromPdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                <div className="css-hboir5">
                                                    <div
                                                        className="css-1hnxo7a"
                                                        style={{ width: 75 }}
                                                    >
                                                        <img
                                                            src={images}
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            extract PDF Images
                                                        </div>
                                                        <p className="chakra-text css-itvw0n"></p>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                        {/* <li className="drop-menu-item ">
                                        <a href="https://anuvadini.aicte-india.org/pdf/Jobapplication" target='_blank'>
                                            <div className="css-hboir5">
                                                <div className="css-1hnxo7a" style={{ width: 75 }}>
                                                    <img src={job} alt="" />
                                                </div>
                                                <div className="css-195k0gj">
                                                    <div className="chakra-heading css-9f6g39">Create PDF Job Application</div>
                                                    <p className="chakra-text css-itvw0n"></p>
                                                </div>
                                            </div>
                                        </a>
                                    </li> */}
                                        {/* <li className="drop-menu-item ">
                                        <a href="https://anuvadini.aicte-india.org/pdf/CamerahrefPdf">
                                            <div className="css-hboir5">
                                                <div className="css-1hnxo7a" style={{ width: 75 }}>
                                                    <img src={cameraPdf} alt="" />
                                                </div>
                                                <div className="css-195k0gj">
                                                    <div className="chakra-heading css-9f6g39">Create PDFs with a camera</div>
                                                    <p className="chakra-text css-itvw0n"></p>
                                                </div>
                                            </div>
                                        </a>
                                    </li> */}
                                        {/* <li className="drop-menu-item ">
                                        <a href="https://anuvadini.aicte-india.org/pdf/Removepdfpages">
                                            <div className="css-hboir5">
                                                <div className="css-1hnxo7a" style={{ width: 75 }}>
                                                    <img src={""} alt="" />
                                                </div>
                                                <div className="css-195k0gj">
                                                    <div className="chakra-heading css-9f6g39">Remove PDF Pages</div>
                                                    <p className="chakra-text css-itvw0n"></p>
                                                </div>
                                            </div>
                                        </a>
                                    </li> */}
                                        {/* <li className="drop-menu-item opctyNgryscle">
                                        <a href="https://anuvadini.aicte-india.org#!">
                                            <div className="css-hboir5">
                                                <div className="css-1hnxo7a" style={{ width: 75 }}>
                                                    <img src={""} alt="" />
                                                </div>
                                                <div className="css-195k0gj">
                                                    <div className="chakra-heading css-9f6g39"></div>
                                                    <p className="chakra-text css-itvw0n"></p>
                                                </div>
                                            </div>
                                        </a>
                                    </li> */}
                                    </ul>
                                </div>
                            </li>

                            <li>
                                <Link
                                    to={undefined}
                                    title="About"
                                    className="meetingMenu dropdown-toggle"
                                    id="dropdownMenuButton8"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    About
                                    <svg
                                        data-v-7e3b073a=""
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        role="Image"
                                        aria-hidden="true"
                                        className="v-icon__svg"
                                        style={{
                                            fontSize: 14,
                                            height: 14,
                                            width: 14,
                                        }}
                                    >
                                        <path
                                            data-v-7e3b073a=""
                                            d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
                                        ></path>
                                    </svg>
                                </Link>
                                <div
                                    className="navDropDown fileDropDown  dropdown-menu"
                                    aria-labelledby="dropdownMenuButton8"
                                >
                                    <ul>
                                        <li className="drop-menu-item">
                                            <Link
                                                to="/AboutUs"
                                                onClick={menuHandle}
                                            >
                                                <div className="css-hboir5_x">
                                                    <div className="css-1hnxo7a"></div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            About Us
                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="drop-menu-item">
                                            <Link
                                                to="/WhatIsAnuvadini"
                                                onClick={menuHandle}
                                            >
                                                <div className="css-hboir5_x">
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            What is Anuvadini?
                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="drop-menu-item">
                                            <Link
                                                to="/Contact"
                                                onClick={menuHandle}
                                            >
                                                <div className="css-hboir5_x">
                                                    <div className="css-1hnxo7a"></div>
                                                    <div className="css-195k0gj">
                                                        <div className="chakra-heading css-9f6g39">
                                                            Contact Us
                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                <Link
                    className="menu-mobile-button"
                    to={undefined}
                    onClick={menuHandle}
                >
                    <Image src={MenuOpen} alt="Menu" />
                </Link>
            </header>
            <Modal show={show} onHide={handleClose}>
                <Modal.Body>
                    <div className="popup-login-signup-bg"></div>
                    <div className="popup-login-signup">
                        <div className="btn-close-popup-login-box">
                            <button
                                type="button"
                                aria-label="Close"
                                onClick={handleClose}
                            >
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M4.818 4.05a.75.75 0 0 0-1.06 1.06l3.181 3.183-3.182 3.182a.75.75 0 1 0 1.061 1.06L8 9.355l3.182 3.182a.75.75 0 1 0 1.06-1.061L9.062 8.293l3.182-3.182a.75.75 0 0 0-1.061-1.06L8 7.231 4.818 4.05Z"
                                        fill="currentColor"
                                    ></path>
                                </svg>
                            </button>
                        </div>
                        <div className="row">
                            <div className="col-lg-12 p-0 login-left-box">
                                {/* <!--Start Login Box--> */}
                                <div className="login-box">
                                    <div>
                                        <div className="block"></div>

                                        {/* <!-- Start Login Area --> */}
                                        {authCategory === 0 ? (
                                            <div className="LoginArea">
                                                <h3>
                                                    Log in or sign up in seconds
                                                </h3>
                                                <p>
                                                    Use your email to continue
                                                    with ANUVADINI!
                                                </p>
                                                <div className="or-line-box">
                                                    <hr />
                                                    <span className="or-txt">
                                                        or
                                                    </span>
                                                </div>

                                                <div className="social-btn-box">
                                                    <div className="btn-google">
                                                        <svg
                                                            width="24"
                                                            height="24"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                d="M20.64 12.2c0-.63-.06-1.25-.16-1.84H12v3.49h4.84a4.14 4.14 0 0 1-1.8 2.71v2.26h2.92a8.78 8.78 0 0 0 2.68-6.62z"
                                                                fill="#4285F4"
                                                            ></path>
                                                            <path
                                                                d="M12 21a8.6 8.6 0 0 0 5.96-2.18l-2.91-2.26a5.4 5.4 0 0 1-8.09-2.85h-3v2.33A9 9 0 0 0 12 21z"
                                                                fill="#34A853"
                                                            ></path>
                                                            <path
                                                                d="M6.96 13.71a5.41 5.41 0 0 1 0-3.42V7.96h-3a9 9 0 0 0 0 8.08l3-2.33z"
                                                                fill="#FBBC05"
                                                            ></path>
                                                            <path d="M12 6.58c1.32 0 2.5.45 3.44 1.35l2.58-2.59A9 9 0 0 0 3.96 7.95l3 2.34A5.36 5.36 0 0 1 12 6.58z"></path>
                                                        </svg>
                                                        Continue with Google
                                                    </div>
                                                </div>
                                                <div>
                                                    <form className="login-form">
                                                        <div className="form-group mt-3">
                                                            <label
                                                                htmlFor="email"
                                                                className="label-text"
                                                            >
                                                                Email Address
                                                            </label>
                                                            <input
                                                                autoFocus="autofocus"
                                                                id="email"
                                                                type="email"
                                                                className="form-input form-control"
                                                                placeholder="name@example.com"
                                                            />
                                                        </div>
                                                        <div className="form-group mt-3">
                                                            <label
                                                                htmlFor="password"
                                                                className="label-text"
                                                            >
                                                                Password
                                                            </label>
                                                            <input
                                                                data-testing-id="password"
                                                                id="password"
                                                                type="password"
                                                                className="form-input form-control"
                                                            />
                                                        </div>
                                                        <div className="form-group mt-3">
                                                            <button
                                                                className="button orange"
                                                                type="submit"
                                                            >
                                                                Sign In
                                                            </button>
                                                        </div>
                                                    </form>
                                                </div>
                                                <div className="mt-1">
                                                    <Link
                                                        href="#!"
                                                        className="clickSignupArea"
                                                        onClick={() =>
                                                            setAuthCategory(1)
                                                        }
                                                    >
                                                        New User?
                                                    </Link>
                                                    &nbsp;&nbsp;
                                                    <Link
                                                        to="#!"
                                                        className="clickResetPassArea"
                                                        onClick={() =>
                                                            setAuthCategory(2)
                                                        }
                                                    >
                                                        Forgot Password?
                                                    </Link>
                                                </div>
                                            </div>
                                        ) : authCategory === 1 ? (
                                            <div className="SignupArea">
                                                <h3>Sign up in seconds</h3>
                                                <p>
                                                    Use your email to continue
                                                    with ANUVADINI!
                                                </p>
                                                <div className="or-line-box">
                                                    <hr />
                                                    <span className="or-txt">
                                                        or
                                                    </span>
                                                </div>
                                                <div>
                                                    <form className="login-form">
                                                        <div className="form-group">
                                                            <label
                                                                htmlFor="email"
                                                                className="label-text"
                                                            >
                                                                Email Address
                                                            </label>
                                                            <input
                                                                autoFocus="autofocus"
                                                                id="email"
                                                                type="email"
                                                                className="form-input form-control"
                                                                placeholder="name@example.com"
                                                            />
                                                        </div>
                                                        <div className="form-group mt-3">
                                                            <label
                                                                htmlFor="password"
                                                                className="label-text"
                                                            >
                                                                Password
                                                            </label>
                                                            <input
                                                                data-testing-id="password"
                                                                id="password"
                                                                type="password"
                                                                className="form-input form-control"
                                                            />
                                                        </div>
                                                        <div className="form-group mt-3">
                                                            <button
                                                                className="button orange"
                                                                type="submit"
                                                            >
                                                                Sign Up
                                                            </button>
                                                        </div>
                                                    </form>
                                                </div>
                                                <div className="mt-1">
                                                    <Link
                                                        to="#!"
                                                        className="clickLoginArea"
                                                        onClick={() =>
                                                            setAuthCategory(0)
                                                        }
                                                    >
                                                        Login?
                                                    </Link>
                                                    &nbsp;&nbsp;
                                                    <Link
                                                        to="#!"
                                                        className="clickResetPassArea"
                                                        onClick={() =>
                                                            setAuthCategory(2)
                                                        }
                                                    >
                                                        Forgot Password?
                                                    </Link>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="ResetPassArea">
                                                <h3>Forgot Password</h3>
                                                <p>
                                                    Use your email to continue
                                                    with ANUVADINI!
                                                </p>
                                                <div className="or-line-box">
                                                    <hr />
                                                    <span className="or-txt">
                                                        or
                                                    </span>
                                                </div>
                                                <div>
                                                    <form className="login-form">
                                                        <div className="form-group">
                                                            <label
                                                                htmlFor="email"
                                                                className="label-text"
                                                            >
                                                                Email Address
                                                            </label>
                                                            <input
                                                                autoFocus="autofocus"
                                                                id="email"
                                                                type="email"
                                                                className="form-input form-control"
                                                                placeholder="name@example.com"
                                                            />
                                                        </div>
                                                        <div className="form-group mt-3">
                                                            <button
                                                                className="button orange"
                                                                type="submit"
                                                            >
                                                                Submit
                                                            </button>
                                                        </div>
                                                    </form>
                                                </div>
                                                <div className="mt-1">
                                                    <Link
                                                        to="#!"
                                                        className="clickSignupArea"
                                                        onClick={() =>
                                                            setAuthCategory(1)
                                                        }
                                                    >
                                                        Sign Up?
                                                    </Link>
                                                    &nbsp;&nbsp;
                                                    <Link
                                                        to="#!"
                                                        className="clickLoginArea"
                                                        onClick={() =>
                                                            setAuthCategory(0)
                                                        }
                                                    >
                                                        Login?
                                                    </Link>
                                                </div>
                                            </div>
                                        )}
                                        {/* <!-- End ResetPassArea Area --> */}

                                        <div className="sml-txt">
                                            <p>
                                                {' '}
                                                By continuing, you agree to our{' '}
                                                <Link
                                                    to="/tirmOfUse"
                                                    className="undeline"
                                                    onClick={handleClose}
                                                >
                                                    Terms Of Use
                                                </Link>{' '}
                                                and{' '}
                                                <Link
                                                    to="/privacyPolicy"
                                                    className="undeline"
                                                    onClick={handleClose}
                                                >
                                                    Privacy Policy
                                                </Link>
                                                .
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                {/* <!--End Login Box-->
            <!--Start Signup Box--> */}
                                <div className="signup-box"></div>
                                {/* <!--End Signup Box--> */}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default Header
